import { Spinner } from 'primsell-shared-layer/assets/icons'
import { LinearSpiner } from 'primsell-shared-layer/assets/icons'
import styled, { css } from 'styled-components'

export interface ILoaderStylesProps {
  colors: {
    primaryColor: string
    secondaryColor: string
  }
}

const loaderStyles = css<ILoaderStylesProps>`
  margin: auto;
  stop {
    &:first-child {
      stop-color: ${({ colors }) => colors.primaryColor};
    }
    &:last-child {
      stop-color: ${({ colors }) => colors.secondaryColor};
    }
  }
`

export const Loader = styled(Spinner)`
  ${loaderStyles}
`
export const LinearLoader = styled(LinearSpiner)`
  ${loaderStyles}
`
